// src/api/axiosInstance.js
import axios from 'axios';

const API_BASE_URL = process.env.NODE_ENV === 'production' 
    ? 'https://adaptivemarketing.mazereality.com/api'
    : 'http://localhost:5000/api';

// Create an Axios instance with default headers
const createAxiosInstance = () => {
    const instance = axios.create({
        baseURL: API_BASE_URL,
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
    });

    // Add request interceptor for logging and auth
    instance.interceptors.request.use(
        (config) => {
            // Get the token from localStorage using the correct key
            const token = localStorage.getItem('authToken');
            
            // If token exists, add it to the headers
            if (token) {
                config.headers['Authorization'] = `Bearer ${token}`;
            }

            console.log('Making request to:', config.url);
            console.log('With headers:', config.headers);
            return config;
        },
        (error) => {
            console.error('Request error:', error);
            return Promise.reject(error);
        }
    );

    // Add response interceptor for logging
    instance.interceptors.response.use(
        (response) => {
            console.log('Response received:', response.status, response.data);
            return response;
        },
        (error) => {
            // Don't log 400 errors for "Knowledge Not Found" as they're expected
            if (!(error.response?.status === 400 && error.response?.data?.message === 'Knowledge Not Found')) {
                console.error('Response error:', error.response?.status, error.response?.data);
            }
            return Promise.reject(error);
        }
    );

    return instance;
};

// Create a default instance
const defaultInstance = createAxiosInstance();

// Export the default instance for backward compatibility
export default defaultInstance;

// Export a function to get an instance with the current token
export const getApi = () => {
    return createAxiosInstance();
};
